<div class="min-h-screen bg-gray-50 p-4 md:p-6">
    <!-- Header -->
    <div class="mb-6">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
                <h1 class="text-2xl font-bold text-gray-900">Links de Pago</h1>
                <p class="text-gray-500 mt-1">Gestión de links de pago generados en Wompi</p>
            </div>
        </div>
    </div>

    <!-- Filtros -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
            <!-- Búsqueda -->
            <div class="lg:col-span-2">
                <label class="block text-sm font-medium text-gray-700 mb-1">Buscar</label>
                <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="onFilterChange()"
                    placeholder="Nombre, documento, NIT, ID Wompi..."
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            </div>

            <!-- Estado -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                <select [(ngModel)]="isActiveFilter" (change)="onFilterChange()"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                    <option [ngValue]="null">Todos</option>
                    <option [ngValue]="true">Activos</option>
                    <option [ngValue]="false">Inactivos</option>
                </select>
            </div>

            <!-- Fecha Desde -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Desde</label>
                <input type="date" [(ngModel)]="dateFrom" (change)="onFilterChange()"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            </div>

            <!-- Fecha Hasta -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Hasta</label>
                <input type="date" [(ngModel)]="dateTo" (change)="onFilterChange()"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            </div>
        </div>

        <div class="flex justify-between items-center mt-4">
            <button (click)="clearFilters()" class="text-sm text-gray-600 hover:text-gray-900 flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
                Limpiar filtros
            </button>
            <span class="text-sm text-gray-500">{{ totalCount }} resultados</span>
        </div>
    </div>

    <!-- Tabla -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                    <tr>
                        <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Tipo / Beneficiario
                        </th>
                        <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Proyecto
                        </th>
                        <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                            (click)="toggleSortOrder()">
                            <span class="flex items-center gap-1">
                                Monto
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        [attr.d]="sortDescending ? 'M19 9l-7 7-7-7' : 'M5 15l7-7 7 7'" />
                                </svg>
                            </span>
                        </th>
                        <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Fecha Generación
                        </th>
                        <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Vencimiento
                        </th>
                        <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Estado
                        </th>
                        <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Acciones
                        </th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                    <tr *ngFor="let link of paymentLinks" class="hover:bg-gray-50 transition-colors">
                        <td class="px-4 py-3">
                            <div class="flex items-center gap-2">
                                <span
                                    class="inline-flex items-center justify-center w-8 h-8 rounded-full text-xs font-medium"
                                    [ngClass]="link.planType === 'Individual' ? 'bg-blue-100 text-blue-600' : 'bg-purple-100 text-purple-600'">
                                    {{ link.planType === 'Individual' ? 'I' : 'C' }}
                                </span>
                                <div>
                                    <div class="font-medium text-gray-900">
                                        {{ link.participantName || link.companyName || '-' }}
                                    </div>
                                    <div class="text-xs text-gray-500">
                                        {{ link.participantDocument || link.companyNit || '-' }}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3">
                            <div class="text-sm text-gray-900">{{ link.projectName || 'Sin proyecto' }}</div>
                            <div *ngIf="link.quotaNumber" class="text-xs text-gray-500">Cuota {{ link.quotaNumber }}
                            </div>
                            <div *ngIf="!link.quotaNumber" class="text-xs text-gray-400 italic">Sin cuota asignada</div>
                        </td>
                        <td class="px-4 py-3">
                            <div class="font-semibold text-gray-900">
                                {{ formatCurrency(link.amount, link.currencyCode) }}
                            </div>
                            <div *ngIf="link.originalAmount && link.currencyCode !== 'COP'"
                                class="text-xs text-gray-500">
                                Original: {{ formatCurrency(link.originalAmount, 'USD') }}
                            </div>
                        </td>
                        <td class="px-4 py-3 text-sm text-gray-600">
                            {{ formatDate(link.generatedDate) }}
                        </td>
                        <td class="px-4 py-3 text-sm text-gray-600">
                            {{ formatDate(link.expirationDate) }}
                        </td>
                        <td class="px-4 py-3">
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                                [ngClass]="getStatusClass(link)">
                                {{ getStatusText(link) }}
                            </span>
                        </td>
                        <td class="px-4 py-3">
                            <div class="flex items-center justify-center gap-2">
                                <button (click)="copyToClipboard(link.paymentUrl)" title="Copiar link"
                                    class="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                                    </svg>
                                </button>
                                <button (click)="viewDetail(link.id)" title="Ver detalle"
                                    class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Empty State -->
        <div *ngIf="paymentLinks.length === 0" class="text-center py-12">
            <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
            </svg>
            <h3 class="mt-2 text-sm font-medium text-gray-900">No hay links de pago</h3>
            <p class="mt-1 text-sm text-gray-500">No se encontraron links con los filtros seleccionados.</p>
        </div>

        <!-- Paginación -->
        <div *ngIf="paymentLinks.length > 0" class="border-t border-gray-200 px-4 py-3 bg-gray-50">
            <p-paginator [rows]="pageSize" [totalRecords]="totalCount" [rowsPerPageOptions]="[10, 20, 50]"
                (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} links">
            </p-paginator>
        </div>
    </div>
</div>